import React, { useEffect, useRef, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import {
  delivery1,
  delivery2,
  delivery3,
  deliveryImg,
  headingIcon,
  order1,
  order2,
  placeImg,
  playIcon,
  shape1,
  shape2,
  shape3,
  ttw43,
  work1,
  work2,
  work3,
  work4,
  workImg,
} from "../../assets/img";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { data } from "../edit/data";
import {
  fetchHomeJsonList,
  fetchPostalCodes,
  getSettingsWBDvedio,
} from "../../redux/Actions";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import axios from "../../config";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { UKPostalCode } from "../core/regex";
import * as yup from "yup";
import { checkShopListFlow, setValue } from "../../utility";
import {
  fetchAddressByPincode,
  fetchGetShopByPinCode,
  fetchSaveAddress,
} from "../../redux/Actions/checkoutPageActions";
import Select from "react-select";
import {
  clearCart,
  clearCartCount,
  setOrderType,
} from "../../redux/Actions/cartCountAction";
import { clearUserProductCategories } from "../../redux/Actions/productCategoriesAction";

const images = [
  "assets/shoe-repair/close-up-engraving-art-tools.jpg",
  "assets/shoe-repair/cobbler-works-his-workshop.jpg",
  "assets/shoe-repair/mature-shoemaker-workshop-making-shoes.jpg",
  "assets/shoe-repair/shoemaker-workshop-making-shoes.jpg",
];

const searchPinCodeFormSchema = yup.object().shape({
  pinCode: yup
    .string()
    .required("Pin code is required")
    .matches(UKPostalCode, "Enter a valid Pin code")
    .trim()
    .max(8, "Enter a valid Pin code"),
});

const addressFormSchema = yup.object().shape({
  address: yup
    .object()
    .shape({
      label: yup.string().required("Address is required to proceed"),
      value: yup.string().required("Address is required to proceed"),
    })
    .test("address.value", "Address is required to proceed", (value: any) => {
      if (value.value == "") {
        return false;
      } else return true;
    })
    .required("Address is required to proceed"),
});

function WBD() {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const Url = window.location.host;
  const blogUrl = `https://blog.${Url}`;
  const base_url = process.env.REACT_APP_BACKEND_URL;
  const homedata: any = useSelector<any>((state) => state?.homeJsonList);
  const [areaCovered, setAreaCovered] = useState<any | null>({});
  const [settings, setSettings] = useState<any>({});
  const [coveredArea, setCoveredArea] = useState(false);
  const [postalCodeList, setPostalCodeList] = useState([]);
  const [postalCodeValue, setPostalCodeValue] = useState("");
  const state: any = useSelector((state) => state);
  const [checkWithNewPin, setCheckWithNewPin] = useState(true);
  const href = window.location.href;
  const [areaData, setAreaData] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState<any>(null);
  const [editedData, setJsonData] = useState<any>();
  const jsonData: any = useSelector<any>((state) => state.homeJsonList);
  const [isPlaying, setIsPlaying] = useState(false);
  const [wbdVedio, setWBDVedio] = useState("");

  const handlePlayClick = () => {
    setIsPlaying(true);
  };
  const handleCloseClick = () => {
    setIsPlaying(false);
  };
  const areaOptions: any = useSelector<any>(
    (state) => state?.addressByPincode?.data?.address_list
  );
  const [play, setPlay] = useState(false);
  const [listOfSuggestedAddress, setListOfSuggestedAddress] = useState([]);
  const settingsslider = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
  };

  const videoRef = useRef<HTMLVideoElement>(null);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setPlay(true);
    }
  };

  const settingsData: any = useSelector<any>((state) => state?.settings);
  useEffect(() => {
    setSettings(settingsData);
  }, [settingsData]);

  // Import specific css for this page
  useEffect(() => {
    if (
      window.location.href.includes("laundryup") ||
      (window.location.href.includes("localhost") &&
        window.location.href.includes("wbd"))
    ) {
      import("../../assets/css/laundryup.css");
    }
    submitPostalForm("");
    getSettingsWBDvedio().then((settingsData: any) => {
      setWBDVedio(settingsData?.WebsiteSettings?.wbd_video);
    });
  }, []);

  // useEffect(() => {}, [homedata]);
  // useEffect(() => {
  //   let currentShopId = localStorage.getItem("currentShopHome") || null;
  //   const url = new URL(window.location.href);
  //   const url_array = url.pathname.split("/").filter(Boolean);
  //   let shop_name = url_array[1];
  //   const headers = {
  //     Accept: "application/json",
  //   };

  //   axios.get(`${base_url}/api/areas_covered?shop_name=${shop_name}&shop_id=${currentShopId}`, {
  //       headers: headers,
  //     })
  //     .then((e:any) => {
  //       setAreaCovered({ data: e.data });
  //     });
  // }, []);
  // const popAreadCovered = (areaList: any) => {
  //   var test = Object.keys(areaList).slice(0, 6).map((location, locationindex) => {
  //     let cityArr = areaList[location].toString().split(",").slice(0, 1);
  //       console.log("city",cityArr)
  //     return (
  //       <>
  //       <div key={locationindex}>
  //         {cityArr.map((city: any, cityIndex: any) => (
  //           <li key={cityIndex}>
  //             <a
  //               // href="#"
  //               // onClick={(e) => {
  //               //   e.preventDefault();
  //               //   navigate("/dry-cleaners/" + city);
  //               // }}
  //             >
  //               {city}
  //             </a>
  //           </li>
  //         ))}

  //         </div>
  //       </>
  //     );
  //   });

  //   return test;
  // };
  //  const popAreadCovered2 = (areaList: any) => {
  //     if (Object.keys(areaList).length > 6) {
  //     return (
  //         <button key="showMore" className="ftransbtn" onClick={navigateToAreaCovered}>
  //             Show More
  //         </button>
  //     );
  // }
  //   };
  // const navigateToAreaCovered = () => {
  //   const shopName: any = localStorage.getItem("currentShopName");
  //   if (shopName) {
  //   const finalResult = shopName
  //     .trim()
  //     .replace(/\s(.)/g, (match: any) => match.toUpperCase())
  //     .replace(/\s/g, "")
  //     .replace(/^(.)/, (match: any) => match.toLowerCase());
  //   if (shopName) {
  //     navigate(`/shop/${finalResult}/areaCovered`);
  //   } else {
  //     navigate("/areaCovered");
  //   }
  // } else {
  //   navigate("/areaCovered");
  // }
  // };

  const {
    handleSubmit: handlePinCodeSubmit,
    control: pinCodeFormControl,
    setError: setPinCodeFormError,
    setValue: setPinCodeFormValue,
    formState: { errors: pinCodeFormError },
  } = useForm({
    resolver: yupResolver(searchPinCodeFormSchema),
    mode: "onChange",
    defaultValues: {
      pinCode: "",
    },
  });

  // const handleChange = (e: any) => {
  //   setCoveredArea(false);
  //   const { value } = e.target;
  //   const updateValue = value.replace(/\s/g, "");
  //   setPinCodeFormValue("pinCode", updateValue);
  //   if (value.length > 0) {
  //     dispatch(fetchPostalCodes(updateValue));
  //   }
  //   setPostalCodeValue(updateValue);
  // };

  useEffect(() => {
    if (state) {
      setPostalCodeList(state.postalCodeList);
    }
    // Load first option as default from areaOptions in setSelectedAddress
    if (areaOptions && areaOptions.length > 0) {
      setSelectedAddress(areaOptions[0]);
      setAddressFormValue("address", areaOptions[0]);
      if (getValuesAddressForm("address")?.value != "") {
        clearErrors();
      }
    }
  }, [state]);

  // const onSearch = (searchTerm: any) => {
  //   setPinCodeFormValue("pinCode", searchTerm);
  //   setPostalCodeValue(searchTerm);
  //   setValue("postalCode", searchTerm.toUpperCase());
  // };

  // const fetchCoveredAreaCodes = async () => {
  //   const base_url = process.env.REACT_APP_BACKEND_URL;
  //   try {
  //     const response = await axios({
  //       method: "get",
  //       url: `${base_url}/api/areas_covered_postcodes`,
  //       headers: {
  //         Accept: "application/json",
  //         "Access-Control-Allow-Methods": "GET, POST",
  //         "Access-Control-Allow-Origin": "*",
  //       },
  //     });
  //     if (response.data.Response.response_code == "1") {
  //       setAreaData(response.data.data);
  //     } else {
  //       return false;
  //     }
  //   } catch (error) {}
  // };

  const submitPostalForm = async (data: any) => {
    localStorage.setItem("postalCode", JSON.stringify("WBD"));
    const shop = await dispatch(fetchGetShopByPinCode(JSON.stringify("WBD")));
    // if (shop) {
    setCoveredArea(false);
    const result = await dispatch(fetchAddressByPincode());
    if (result.status == 200 && result.data.data?.address_list.length > 0) {
      setCheckWithNewPin(false);
      setCoveredArea(false);
    } else {
      if (href.includes("wblaundry") || href.includes("localhost")) {
        navigate("/areaNotCovered");
      } else {
        setPinCodeFormError("pinCode", {
          type: "server",
          message: "Area not covered",
        });
        // await fetchCoveredAreaCodes();
        setCoveredArea(true);
      }
    }
    // } else {

    // }
  };

  const {
    handleSubmit: handleAddressSubmit,
    control: addressFormControl,
    setError: addressFormSetError,
    setValue: setAddressFormValue,
    getValues: getValuesAddressForm,
    reset: resetAddressForm,
    clearErrors,
    formState: { errors: addressFormError },
  } = useForm({
    resolver: yupResolver(addressFormSchema),
    mode: "onChange",
    defaultValues: {
      address: { value: "", label: "Select your address..." },
    },
  });
  const handleAddressChange = async (selected: any) => {
    setSelectedAddress(selected);
    setAddressFormValue("address", selected);
    if (getValuesAddressForm("address")?.value != "") {
      clearErrors();
    }
  };

  const submitAddressChange = async () => {
    let postalCode: any = localStorage.getItem("postalCode");
    if (getValuesAddressForm("address")?.value == "") {
      addressFormSetError("address", {
        type: "server",
        message: "Address is required to proceed",
      });
    } else {
      clearErrors();
      localStorage.setItem(
        "selectedAddressBeforeLogin",
        JSON.stringify(selectedAddress)
      );
      const split_address = selectedAddress?.value?.split(",");
      if (localStorage.getItem("token")) {
        // handle api
        const contact_name = JSON.parse(localStorage.getItem("userDetails")!)
          .data?.user_info.name;
        const mobile_number = JSON.parse(localStorage.getItem("userDetails")!)
          .data?.user_info.mobile;
        const address = selectedAddress?.value?.split(",");
        const payloadData = {
          address_type: "pickup",
          address_details: `{"contact_name":"${contact_name}","mobile_number":"${mobile_number}","line_1":"${address[0].trim()}","line_2":"${address[1].trim()}","line_3":"${address[2].trim()}","line_4":"${address[3].trim()}","locality":"${address[4].trim()}","city":"${address[5].trim()}","county":"${address[6].trim()}","label":"Home","pincode":"${address[7].trim()}"}`,
        };
        localStorage.setItem("postalCode", JSON.stringify(address[7].trim()));
        const uniqueAddress = await dispatch(fetchSaveAddress(payloadData));
        if (
          uniqueAddress.status ||
          uniqueAddress.message == "Address already exists"
        ) {
          let host = window.location.hostname;
          // If host contains fulham move to checkout directly

          const results = await dispatch(fetchGetShopByPinCode(postalCode));

          if (!results) {
            setPinCodeFormError("pinCode", {
              type: "server",
              message: "Area not covered",
            });
            // await fetchCoveredAreaCodes();
            setCoveredArea(true);
            return;
          }
          dispatch(setOrderType(0));
          setValue("orderType", 0);
          setValue("wbd", true);
          // localStorage.removeItem("cartInformationData");
          // dispatch(clearCartCount());
          // dispatch(clearCart());
          // dispatch(clearUserProductCategories());
          localStorage.removeItem("isloaded");
          // dispatch(clearSplitPrice());
          let userName = JSON.parse(localStorage.getItem("userDetails")!);
          // userName == null ? navigate("/guestLogin") : navigate("/productLists");
          if (userName == null) {
            localStorage.setItem("from", "wbd");
            navigate("/login");
          } else {
            localStorage.setItem("from", "wbd");
            navigate("/productLists");
          }
        } else {
          addressFormSetError("address", {
            type: "server",
            message: "Unable to set address try again later",
          });
        }
      } else {
        localStorage.setItem(
          "postalCode",
          JSON.stringify(split_address[7].trim())
        );

        let host = window.location.hostname;
        // If host contains fulham move to checkout directly
        const results = await dispatch(fetchGetShopByPinCode(postalCode));

        if (!results) {
          setPinCodeFormError("pinCode", {
            type: "server",
            message: "Area not covered",
          });
          // await fetchCoveredAreaCodes();
          setCoveredArea(true);
          return;
        }
        dispatch(setOrderType(0));
        setValue("orderType", 0);
        setValue("wbd", true);
        // localStorage.removeItem("cartInformationData");
        // dispatch(clearCartCount());
        // dispatch(clearCart());
        // dispatch(clearUserProductCategories());
        localStorage.removeItem("isloaded");
        // dispatch(clearSplitPrice());
        let userName = JSON.parse(localStorage.getItem("userDetails")!);
        // userName == null ? navigate("/guestLogin") : navigate("/checkOut");
        if (userName == null) {
          localStorage.setItem("from", "wbd");
          navigate("/login");
        } else {
          localStorage.setItem("from", "wbd");
          navigate("/productLists");
        }
      }
    }
  };
  useEffect(() => {
    setJsonData(jsonData);
  }, [jsonData]);
  console.log("wed pag data", editedData);

  return (
    <>
      {/* <!-- Main Wrapper --> */}
      <div className="main-wrapper">
        {/* <!-- Header --> */}
        {/* <header className="header">
          <div className="container">
            <nav className="navbar navbar-expand-lg header-nav">
              <div className="navbar-header">
                <a id="mobile_btn" href="javascript:void(0);">
                  <span className="bar-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                </a>
                <div className="logo-main">
                  <a href="index.html" className="navbar-brand logo">
                    <span>
                      <img src="../../assets/img/laundryup/logo.svg" className="img-fluid" alt="Logo" />
                    </span>
                  </a>
                  <a href="index.html" className="logo-web">
                    <span>
                      <img src="../../assets/img/laundryup/logo-web.svg" className="img-fluid" alt="Logo" />
                    </span>
                  </a>
                </div>
                <a href="index.html" className="navbar-brand logo-small">
                  <img src="../../assets/img/laundryup/logo.svg" className="img-fluid" alt="Logo" />
                </a>
              </div>
              <div className="main-menu-wrapper">
                <div className="menu-header">
                  <a href="index.html" className="menu-logo">
                    <span>
                      <img src="../../assets/img/laundryup/logo.svg" className="img-fluid" alt="Logo" />
                    </span>
                  </a>
                  <a id="menu_close" className="menu-close" href="javascript:void(0);"> 
                    <i className="fas fa-times"></i>
                  </a>
                </div>
                <ul className="main-nav">
                  <li className="active">
                    <a href="index.html">Home</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);">Pricing</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);">Area Covered</a>
                  </li>
                  <li>
                    <a href="javascript:void(0);">Blog</a>
                  </li>
                  <li className="login-link">
                    <a href="javascript:void(0);">Sign In</a>
                  </li>
                </ul>
              </div>
              <ul className="nav header-navbar-rht">
                <li className="nav-item cart-item">
                  <div className="cart-flex">
                    <div className="cart-icon">
                      <img src="../../assets/img/laundryup/icons/cart-icon.svg" alt="Icon" />
                    </div>
                    <div className="cart-text">
                      <p>items : 0</p>
                      <h6>£0.00</h6>
                    </div>
                  </div>
                </li>
                <li className="nav-item">
                  <a href="javascript:void(0);" className="nav-link header-login">
                    <i className="ti ti-user"></i> Sign In
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </header> */}
        {/* <!-- /Header --> */}

        {/* <!-- Hero --> */}
        <section
          className="hero-section"
          style={{ position: "relative", overflow: "hidden" }}
        >
          <img
            src={editedData?.theme_6?.home?.section_1?.banner}
            alt=""
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: -1,
            }}
          />
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12 aos" data-aos="fade-up">
                <div className="hero-content">
                  <h1>{jsonData?.theme_6?.home?.section_1?.title}</h1>
                  <p> {jsonData?.theme_6?.home?.section_1?.sub_heading_top}</p>
                  {/* <form onSubmit={handlePinCodeSubmit(submitPostalForm)}>
                    <div className={`${checkWithNewPin == false ? "d-none" : ""}`}>
                      <small className="text-danger postvalidation">
                        {pinCodeFormError.pinCode?.message}
                      </small>
                      <div className="hero-form">
                        <div className="hero-input">
                            <div className="postcodeform">
                                <Controller
                                  name="pinCode"
                                  control={pinCodeFormControl}
                                  render={({ field }) => (
                                    <input
                                      type="text"
                                      id="postcode-input"
                                      {...field}
                                      placeholder={
                                        homedata?.theme_3?.home?.section_1?.btn_group
                                          ?.btn1?.placeholder
                                      } 
                                      className={`ui-autocomplete-input ${
                                        pinCodeFormError.pinCode ? "invalid" : ""
                                      }`}
                                      onChange={handleChange}
                                      autoComplete="off"
                                    />
                                  )}
                                />
                                <div className="dropdown">
                                  {postalCodeList
                                    .filter((item: any) => {
                                      const searchTerm = postalCodeValue.toLowerCase();
                                      const mainValue = item.postcode.toLowerCase();

                                      return (
                                        searchTerm &&
                                        mainValue.startsWith(searchTerm) &&
                                        mainValue !== searchTerm
                                      );
                                    })
                                    .slice(0, 10)
                                    .map((item: any) => (
                                      <div
                                        onClick={() => onSearch(item.postcode)}
                                        className="dropdown-row"
                                        key={item.postcode}
                                      >
                                        <i className="fas fa-map-marker-alt"></i>
                                        {item.postcode}
                                      </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="hero-btn">
                          <button type="submit" className="btn btn-secondary">
                            Book Now <i className="ti ti-arrow-narrow-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form> */}
                  <form>
                    {/* <div
                      className={`adrsselectform ${
                        checkWithNewPin == true ? "d-none" : ""
                      }`}
                    >
                      <small className="text-danger postvalidation">
                        {addressFormError.address?.message}
                      </small> */}
                    <div className="adrsselectdd">
                      <Controller
                        name="address"
                        control={addressFormControl}
                        render={({ field }) => (
                          <Select
                            placeholder="Select address..."
                            {...field}
                            value={selectedAddress}
                            className={`${
                              addressFormError.address ? "invalid" : ""
                            }`}
                            onChange={handleAddressChange}
                            onFocus={() => {
                              if (getValuesAddressForm("address").value == "") {
                                addressFormSetError("address", {
                                  type: "server",
                                  message: "Address is required to proceed",
                                });
                              } else {
                                clearErrors();
                              }
                            }}
                            options={areaOptions}
                          />
                        )}
                      />

                      {/* <input
                          type="button"
                          value="Continue"
                          className="btn btn-secondary"
                          onClick={submitAddressChange}
                        /> */}
                      <button
                        type="button"
                        className="btn-secondary"
                        onClick={submitAddressChange}
                        style={{
                          backgroundColor: `#${jsonData?.theme_6?.home?.section_1?.bg_color}`,
                          color: `#${jsonData?.theme_6?.home?.section_1?.color}`,
                        }}
                      >
                        {jsonData?.theme_6?.home?.section_1?.text}{" "}
                        <i className="ti ti-arrow-narrow-right"></i>
                      </button>
                    </div>
                    {/* <div className="adrsselect-or text-white">OR</div>
                      <div className="adrsselect-link">
                        <a
                          className="cursor-pointer text-white"
                          onClick={() => {
                            setCheckWithNewPin(true);
                          }}
                        >
                          Check with another Postcode
                        </a>
                      </div> */}
                    {/* </div> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- /Hero --> */}

        {/* <!-- Work --> */}
        <div className="work-section">
          <div className="work-shape">
            <img
              src={shape1}
              className="shape-01 aos"
              data-aos="fade-up"
              alt="Shape"
            />
            <img
              src={shape2}
              className="shape-02 aos"
              data-aos="zoom-in"
              alt="Shape"
            />
          </div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 aos" data-aos="fade-up">
                <div className="work-img">
                  <img
                    src={jsonData?.theme_6?.home?.section_2?.banner}
                    className="img-fluid"
                    alt="Work"
                  />
                  {/* <a href="javascript:void(0);">
                               <i className="fa fa-play"></i>
                           </a> */}
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="section-header text-start aos"
                  data-aos="fade-up"
                >
                  <h2
                    style={{
                      color: `#${jsonData?.theme_6?.home?.section_2?.title_color}`,
                    }}
                  >
                    {jsonData?.theme_6?.home?.section_2?.title}
                    <img src={headingIcon} />
                  </h2>
                  <p
                    style={{
                      color: `#${jsonData?.theme_6?.home?.section_2?.sub_title_color}`,
                    }}
                  >
                    {jsonData?.theme_6?.home?.section_2?.sub_heading_top}
                  </p>
                </div>
                <div className="row">
                  {jsonData?.theme_6?.home?.section_2?.cards?.map(
                    (val: any, index: any) => {
                      return (
                        <div
                          className="col-md-6 d-flex aos"
                          data-aos="fade-up"
                          key={index}
                        >
                          <div className="work-grid w-100">
                            <div className="work-icon">
                              <img src={val?.image} alt="Icon" />
                              <span>{`0${index + 1}`}</span>
                            </div>
                            <div className="work-text">
                              <h4
                                style={{
                                  color: `#${val?.sub_title_color}`,
                                }}
                              >
                                {val?.title}
                              </h4>
                              <p
                                style={{
                                  color: `#${val?.sub_title_color}`,
                                }}
                              >
                                {val?.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  )}
                  {/* <div className="col-md-6 d-flex aos" data-aos="fade-up">
                             <div className="work-grid w-100">
                               <div className="work-icon">
                                 <img src={work2} alt="Icon" />
                                 <span>02</span>
                               </div>
                               <div className="work-text">
                                 <h4>Step 2</h4>
                                 <p>
                                   Pickup & Drop location to : WB Studios, Leavesden
                                   Park, Watford.
                                 </p>
                               </div>
                             </div>
                           </div>
                           <div className="col-md-6 d-flex aos" data-aos="fade-up">
                             <div className="work-grid w-100">
                               <div className="work-icon">
                                 <img src={work3} alt="Icon" />
                                 <span>03</span>
                               </div>
                               <div className="work-text">
                                 <h4>Step 3</h4>
                                 <p>Choose a time slot – Tuesdays or Fridays only.</p>
                               </div>
                             </div>
                           </div>
                           <div className="col-md-6 d-flex aos" data-aos="fade-up">
                             <div className="work-grid w-100">
                               <div className="work-icon">
                                 <img src={work4} alt="Icon" />
                                 <span>04</span>
                               </div>
                               <div className="work-text">
                                 <h4>Step 4</h4>
                                 <p>
                                   Pay a fixed £5 booking fee to confirm your order.
                                 </p>
                               </div>
                             </div>
                           </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Work --> */}

        {/* <!-- Order --> */}
        <div className="order-section">
          <div className="container">
            <div className="row">
              <div className="col-md-12 aos" data-aos="fade-up">
                <div className="section-header">
                  <h2
                    style={{
                      color: `#${jsonData?.theme_6?.home?.section_3?.title_color}`,
                    }}
                  >
                    {jsonData?.theme_6?.home?.section_3?.title}
                    <img src={headingIcon} />
                  </h2>
                  <p
                    style={{
                      color: `#${jsonData?.theme_6?.home?.section_3?.sub_title_color}`,
                    }}
                  >
                    {jsonData?.theme_6?.home?.section_3?.sub_heading_top}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              {jsonData?.theme_6?.home?.section_3?.cards?.map(
                (val: any, index: number) => (
                  <div
                    className="col-md-6 d-flex aos"
                    data-aos="fade-up"
                    key={index}
                  >
                    <div className="order-grid w-100">
                      <div className="ribbone">
                        <span
                          style={{
                            backgroundColor: `#${val?.flat_rate_bg_color}`,
                            color: `#${val?.flat_color}`,
                          }}
                        >
                          {val?.flat_rate}
                        </span>
                      </div>
                      <div className="order-text">
                        <h4 style={{ color: `#${val?.title_color}` }}>
                          {val?.title}
                        </h4>

                        {Array.isArray(val?.description) &&
                          val.description.map((desc: string, idx: number) => (
                            <p
                              key={idx}
                              style={{ color: `#${val?.description_color}` }}
                            >
                              <i className="ti ti-circle-check-filled"></i>
                              {desc}
                            </p>
                          ))}
                      </div>
                      <div className="order-img">
                        <img src={val?.image} alt="Order" />
                      </div>
                    </div>
                  </div>
                )
              )}

              {/* <div className="col-md-6 d-flex aos" data-aos="fade-up">
                         <div className="order-grid w-100">
                           <div className="ribbone">
                             <span>Per Item</span>
                           </div>
                           <div className="order-text">
                             <h4>Itemized Order</h4>
                             <p>
                               <i className="ti ti-circle-check-filled"></i> Pay per
                               item
                             </p>
                             <p>
                               <i className="ti ti-circle-check-filled"></i> WB Studio
                               pickup, same as Quick Order
                             </p>
                             <p>
                               <i className="ti ti-circle-check-filled"></i> Select
                               each item
                             </p>
                             <p>
                               <i className="ti ti-circle-check-filled"></i> Add
                               special care notes
                             </p>
                             <p>
                               <i className="ti ti-circle-check-filled"></i> Ideal for
                               dry cleaning
                             </p>
                           </div>
                           <div className="order-img">
                             <img src={order2} alt="Order" />
                           </div>
                         </div>
                       </div> */}
            </div>
          </div>
        </div>
        {/* <!-- /Order --> */}

        {/* <!-- Delivery --> */}
        <div className="delivery-section">
          <div className="container">
            <div className="delivery-info">
              <div className="delivery-shape">
                <img src={shape3} alt="Shape" />
              </div>
              <div className="row align-items-center">
                <div className="col-lg-7">
                  <div className="delivery-header aos" data-aos="fade-up">
                    <h2
                      style={{
                        color: `#${jsonData?.theme_6?.home?.section_4?.title_color}`,
                      }}
                    >
                      {jsonData?.theme_6?.home?.section_4?.title}
                    </h2>
                    <p
                      style={{
                        color: `#${jsonData?.theme_6?.home?.section_4?.sub_title_color}`,
                      }}
                    >
                      {jsonData?.theme_6?.home?.section_4?.sub_heading_top}
                    </p>
                  </div>
                  <div className="row">
                    {jsonData?.theme_6?.home?.section_4?.cards?.map(
                      (val: any, index: any) => {
                        return (
                          <div
                            className="col-md-4 d-flex aos"
                            data-aos="fade-up"
                          >
                            <div
                              className="delivery-grid w-100"
                              key={index}
                              // style={{
                              //   backgroundColor: `#${val?.bg_color}`,
                              // }}
                            >
                              <div className="delivery-icon">
                                <img src={val?.image} alt="Icon" />
                              </div>
                              <div className="delivery-text">
                                <h4
                                  style={{
                                    color: `#${val?.title_color}`,
                                  }}
                                >
                                  {val?.title}
                                </h4>
                                <p
                                  style={{
                                    color: `#${val?.sub_title_color}`,
                                  }}
                                >
                                  {val?.sub_heading_top}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
                <div className="col-lg-5 aos" data-aos="fade-up">
                  <div className="delivery-img">
                    <img
                      src={jsonData?.theme_6?.home?.section_4?.banner}
                      className="img-fluid"
                      alt="Delivery"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Delivery --> */}

        {/* <!-- Place --> */}
        <div className="place-section">
          <div className="container">
            <div className="row">
              <div className="col-md-12 aos" data-aos="fade-up">
                <div className="section-header">
                  <h2
                    style={{
                      color: `#${jsonData?.theme_6?.home?.section_5?.title_color}`,
                    }}
                  >
                    {jsonData?.theme_6?.home?.section_5?.title}
                    <img src={headingIcon} />
                  </h2>
                  <p
                    style={{
                      color: `#${jsonData?.theme_6?.home?.section_5?.sub_title_color}`,
                    }}
                  >
                    {/* See a quick step-by-step video on booking your laundry
                             service through our platform */}
                    {jsonData?.theme_6?.home?.section_5?.sub_heading_top}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 aos" data-aos="fade-up">
                <div className="place-img">
                  {!isPlaying ? (
                    <>
                      <img
                        src={jsonData?.theme_6?.home?.section_5?.banner}
                        className="img-fluid"
                        alt="Place"
                      />
                      <a
                        onClick={handlePlayClick}
                        // className="play-button"
                      >
                        <img src={playIcon} alt="Play Icon" />
                      </a>
                    </>
                  ) : (
                    <div className="video-wrapper">
                      <video
                        controls
                        autoPlay
                        className="img-fluid"
                        style={{ width: "100%", height: "auto" }}
                      >
                        <source src={wbdVedio} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                      <a
                        onClick={handleCloseClick}
                        className="wbd-close-button"
                      >
                        <i className="fa fa-times"></i>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Place --> */}

        {/* <!-- Ready --> */}
        <div className="ready-section">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-9 aos" data-aos="fade-up">
                <div className="ready-header">
                  <h2
                    style={{
                      color: `#${jsonData?.theme_6?.home?.section_6?.title_color}`,
                    }}
                  >
                    {jsonData?.theme_6?.home?.section_6?.title}
                  </h2>
                  <p
                    style={{
                      color: `#${jsonData?.theme_6?.home?.section_6?.sub_title_color}`,
                    }}
                  >
                    {jsonData?.theme_6?.home?.section_6?.sub_heading_top}
                  </p>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="ready-btn aos" data-aos="fade-up">
                  <a
                    href="javascript:void(0);"
                    className="btn btn-primary"
                    style={{
                      backgroundColor: `#${jsonData?.theme_6?.home?.section_6?.btn_bg_color}`,
                      color: `#${jsonData?.theme_6?.home?.section_6?.btn_color}`,
                    }}
                  >
                    {jsonData?.theme_6?.home?.section_6?.button_text}{" "}
                    <i className="ti ti-arrow-narrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Ready --> */}

        {/* <!-- Footer --> */}
        {/* <footer className="footer">
          <div className="container">
            <div className="footer-top aos" data-aos="fade-up">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget">
                    <div className="footer-about">
                      <p>Ready to take laundry off your to-do list? services is a local laundry pickup and delivery service that you can order directly from your smart phone.</p>
                    </div>
                    <div className="footer-social">
                      <a href="javascript:void(0);"><i className="fab fa-facebook hi-icon"></i></a>
                      <a href="javascript:void(0);"><i className="fab fa-instagram hi-icon"></i></a>
                      <a href="javascript:void(0);"><i className="fab fa-youtube hi-icon"></i></a>
                      <a href="javascript:void(0);"><i className="fa-brands fa-twitter hi-icon"></i></a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6">
                  <div className="footer-widget">
                    <h2>Quick Links</h2>
                    <ul>
                      <li>
                        <a href="javascript:void(0);">About Us</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Our Services</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Terms & Conditions</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Privacy Policy</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Cookie Policy</a>
                      </li>	
                    </ul>
                  </div>
                </div>
                <div className="col-lg-2 col-md-6">
                  <div className="footer-widget">
                    <h2>Explore</h2>
                    <ul>
                      <li>
                        <a href="javascript:void(0);">How it works</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Services</a>
                      </li>
                      <li>
                        <a href="javascript:void(0);">Locations</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget">
                    <h2>Call Today to Discuss Your Service Needs</h2>
                    <ul>
                      <li>0987654321</li>
                      <li>locallaunderette103@gmail.com</li>
                      <li>admin@laundryup.co.uk</li>
                      <li>103 Eastbury Road, Watford, WD19 4JP</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="copy-rights">
                    <p>
                      © 2025. All rights reserved. | Powered by
                      <a href="javascript:void(0);">www.bestatservices.com</a>
                    <p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer> */}
        {/* <!-- /Footer --> */}

        {/* <!-- Cursor --> */}
        <div className="mouse-cursor cursor-outer"></div>
        <div className="mouse-cursor cursor-inner"></div>
        {/* <!-- /Cursor --> */}
      </div>
      {/* <!-- /Main Wrapper --> */}

      {/* <!-- ScrollToTop --> */}
      {/* <div className="progress-wrap active-progress">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" style={{transition: 'stroke-dashoffset 10ms linear 0s; stroke-dasharray: 307.919px, 307.919px; stroke-dashoffset: 228.265px;'}}></path>
        </svg>
      </div> */}
      {/* <!-- /ScrollToTop --> */}
    </>
  );
}

export default WBD;
